<button appScrollTo
  elementId="sign-in"
  type="button"
  aria-label="Rolar a página até a seção abaixo">
  <i class="icon-arrow-down"></i>
</button>